import defaults from "./default.config"
import deepMergeObjects from "../assets/helpers/mergeObjects.js"

export default defineI18nConfig(() => (deepMergeObjects(defaults, {
	messages: {
		en: {
			//TODO: Maintain Alphabetical order!!!
			cookiesNotice: "At Shambhala headquarters, we use analytical tools to help make your experience better. We’d love to have you" +
				" accept our cookies but we’ll always respect your data choices. Some cookies are necessary for our page to work.",
			discoverMore: "Discover More",
			errorPageMissingBody: "Looks like you wandered into the rabbit hole.\nSorry, there is nothing here at this time.",
			maintenance1: "Our site is down for maintenance, we're working to resolve this issue as quickly as possible",
			maintenance2: "Sending out Shambhalove to all our Farmily,\nwe can't wait to welcome you back Home.",
			maintenanceBtn: "Continue Wandering",
			transferTerm1: "You agree that transferring items will permanently remove them from your account and have verified that items listed for transfer are correct",
			transferTerm2: "You agree that Shambhala Music Festival is not responsible for items transferred in error or to a third party",
			userPortalLogin: "Login to the Customer Portal",
			faqQ1Title: "Are tickets distributed as digital or physical tickets?",
			faqQ1Body: "When purchasing a ticket to Shambhala Music Festival, it is delivered electronically. If you would like to get a physical keepsake to remember your festival experience, you can order a Collectable Hologram when checking out on our ticketing page.",
		},
		fr: {},
	}
})))
